import { Component, OnInit, Output, EventEmitter } from '@angular/core';

import { DataForDisplayingMenuItemsService } from '../services/data-for-displaying-menu-items.service';
import { RailingGenerationService } from '../services/railing/services/railing-generation.service';
import { LoadingSpinnerService } from '../services/loading-spinner.service';
import { RailingLightService } from '../services/railing/light/railing-light.service';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-add-lighting',
  templateUrl: './add-lighting.component.html',
  styleUrls: ['./add-lighting.component.scss']
})
export class AddLightingComponent implements OnInit {
  @Output() step2Editer = new EventEmitter();
  toggleFirst;
  toggleSecond;
  toggleThird;

  lighting = {
    topRailLights: false,
    bottomRailLights: false,
    postAccentLights: false
  };

  topRailLights: boolean = true;
  bottomRailLights: boolean = true;
  postAccentLights: boolean = true;
  note: boolean = false;

  railingType: string;
  infill: string;

  goBack(value) {
    this.step2Editer.emit({ name: value });
  }

  constructor(
    public dataForMenu: DataForDisplayingMenuItemsService,
    private railingGenerationService: RailingGenerationService,
    private railingLightSrvc: RailingLightService,
    private loadingSpinnerSrvc: LoadingSpinnerService
  ) {
    this.dataForMenu.lightingBSubj
      .pipe(
        map((lighting: any) => {
          if (lighting.hasOwnProperty('topRailLights')) {
            this.setTopRailLighting(lighting.topRailLights);
          }
          if (lighting.hasOwnProperty('bottomRailLights')) {
            this.setBottomRailLighting(lighting.bottomRailLights);
          }
          if (lighting.hasOwnProperty('postAccentLights')) {
            this.setPostsLighting(lighting.postAccentLights);
          }
        })
      )
      .subscribe();
  }

  ngOnInit() {
    this.railingGenerationService.build.subscribe(() => {
      const currentChoices = this.dataForMenu.getCurrentParams();
      if (
        currentChoices.railingType === 'DesignRail' &&
        currentChoices.infill === 'horizontalCableBaserail'
      ) {
        this.topRailLights = true;
        this.bottomRailLights = true;
        this.postAccentLights = true;
        this.note = false;
      } else if (
        currentChoices.railingType === 'DesignRail' &&
        currentChoices.infill === 'horizontalCable'
      ) {
        this.topRailLights = true;
        this.bottomRailLights = false;
        this.postAccentLights = true;
        this.note = false;
      } else if (
        currentChoices.railingType === 'DesignRail' &&
        currentChoices.infill !== 'horizontalCable' &&
        currentChoices.infill !== 'horizontalCableBaserail'
      ) {
        this.topRailLights = false;
        this.bottomRailLights = false;
        this.postAccentLights = true;
        this.note = false;
      } else if (currentChoices.railingType === 'Modern') {
        // "Lighting — Only Top Rail options" (spec p.2 rule 6)
        this.topRailLights = true;
        this.bottomRailLights = false;
        this.postAccentLights = false;
        this.note = false;
      } else {
        this.topRailLights = false;
        this.bottomRailLights = false;
        this.postAccentLights = false;
        this.note = true;
      }
    });
  }

  setTopRailLighting(value) {
    this.lighting.topRailLights = value;
    this.loadingSpinnerSrvc.performWork(() => this.railingLightSrvc.switchTopRailLighting(value));
    this.dataForMenu.setLighting({ topRailLights: this.lighting.topRailLights });
  }

  setBottomRailLighting(value) {
    this.lighting.bottomRailLights = value;
    this.loadingSpinnerSrvc.performWork(() =>
      this.railingLightSrvc.switchBottomRailLighting(value)
    );
    this.dataForMenu.setLighting({ bottomRailLights: this.lighting.bottomRailLights });
  }

  setPostsLighting(value) {
    this.lighting.postAccentLights = value;
    this.loadingSpinnerSrvc.performWork(() => this.railingLightSrvc.switchPostLighting(value));
    this.dataForMenu.setLighting({ postAccentLights: this.lighting.postAccentLights });
  }

  // event handlers (start)
  onSetTopRailLighting(e) {
    const value = e.target.checked;
    this.setTopRailLighting(value);
  }

  onSetBottomRailLighting(e) {
    const value = e.target.checked;
    this.setBottomRailLighting(value);
  }

  onSetPostsLighting(e) {
    const value = e.target.checked;
    this.setPostsLighting(value);
  }
  // event handlers (end)
}



// WEBPACK FOOTER //
// ./src/app/add-lighting/add-lighting.component.ts